import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Link } from "react-router-dom";
import { faUserTie } from "@fortawesome/free-solid-svg-icons";
export default function SingleResearches() {
  return (
    <div className="m-full mx-auto max-w-screen-xl  my-8 px-4">
      <h2 className="text-2xl font-semibold mt-5">
        Lorem ipsum dolor sit amet.
      </h2>
      <p className="mb-5">
        <p className="my-2">
          <FontAwesomeIcon icon={faUserTie} className="mr-2" />
          Teacher Name
        </p>
      </p>
      <div className="w-full">
        <img
          src="https://via.placeholder.com/800/400"
          alt=""
          className="img-fluid max-h-[400px]"
        />
      </div>
      <p className="my-2">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam fugit
        itaque neque eligendi, laborum dignissimos magnam dolor ratione animi,
        atque sapiente, fugiat praesentium velit excepturi. Eius unde eos
        temporibus voluptate molestiae eum culpa, sunt, sequi distinctio
        accusantium delectus, sapiente fuga nulla natus sit saepe reiciendis
        odit quod deserunt libero consequuntur aliquid. Deleniti facere
        quibusdam saepe exercitationem ut. Quis distinctio tempore ipsa, unde
        adipisci doloribus blanditiis molestias harum consectetur, voluptas
        possimus beatae sunt ipsum aut officiis velit odio eveniet
        exercitationem. Repellat tempore aperiam blanditiis est totam in error
        sit recusandae harum. Molestias placeat illum dolores? Dolores porro
        aliquid iure in maiores modi nihil quaerat vitae sed ipsam eaque maxime,
        quas, perferendis quae harum aut fuga quis, placeat ad odio corporis
        dolore. Hic corrupti sapiente qui voluptatum, assumenda reprehenderit
        quisquam sequi nesciunt cupiditate eius incidunt error quos. Pariatur
        qui quia nisi enim praesentium officiis nobis neque minima amet aliquam.
        Vel amet distinctio error quaerat quibusdam quidem quas, pariatur
        tempora dolor dolorem aliquid explicabo, exercitationem eius natus
        aliquam! Magnam laborum nesciunt placeat dolorum, vero quidem, quibusdam
        officia enim perferendis, repellat qui voluptates suscipit ipsam? Totam
        recusandae quidem officia dolor necessitatibus aut natus fugit maxime
        consequuntur quos nemo aliquid, illum quo id magni nesciunt commodi
        tempore magnam qui nobis! Accusamus, blanditiis earum expedita, omnis,
        in perspiciatis dolorum officiis provident excepturi numquam deserunt ut
        quis error quas distinctio molestias ratione! Fugit repudiandae
        consequuntur nemo perferendis id libero aspernatur voluptatum rem est.
        Dolor non, nemo quibusdam mollitia explicabo dolorem, ipsam error
        fugiat, eos ad fuga velit?
      </p>
    </div>
  );
}
